import React from "react";
import { useNavigate } from "react-router-dom";
import { Flame, TrendingUp } from "lucide-react";
import { AuraRing } from "@/components/brand/AuraRing";
import { VerifiedBadge } from "@/components/brand/VerifiedBadge";
import { OgBadge } from "@/components/brand/OgBadge";
import { FollowButton } from "@/components/app/FollowButton";
import { mediaUrl, auraFmt } from "@/lib/api";

// A single user result row: avatar, name + verified, @handle · profession, Aura, relationship button.
export function UserRow({ u, showFollow = true, right = null, onClick }) {
  const navigate = useNavigate();
  const go = () => (onClick ? onClick(u) : navigate(`/u/${u.username}`));
  const prof = u.show_category === false ? "" : u.category;
  return (
    <div data-testid={`user-row-${u.username}`} className="flex items-center gap-3 rounded-xl px-2 py-2 hover:bg-white/5">
      <button onClick={go} className="flex min-w-0 flex-1 items-center gap-3 text-left">
        <AuraRing src={mediaUrl(u.picture) || undefined} size={46} ring={2} fallback={u.name} story={u.has_story} storySeen={u.all_seen} />
        <div className="min-w-0">
          <div className="flex items-center gap-1">
            <span className="truncate text-sm font-semibold text-white">{u.name}</span>
            {u.is_verified && <VerifiedBadge size={14} />}{u.is_og && <OgBadge size={14} />}
            {u.is_ai_creator && <span className="rounded-full bg-am-surface3 px-1.5 py-0.5 text-[9px] font-semibold text-am-text2">AI</span>}
          </div>
          <div className="truncate text-xs text-am-text2">@{u.username}{prof ? ` · ${prof}` : ""}</div>
          {(u.aura_total_centi > 0 || u.aura_today_centi > 0) && (
            <div className="mt-0.5 flex items-center gap-2 text-[11px]">
              <span className="flex items-center gap-0.5 text-am-text3"><Flame className="h-3 w-3 aura-text" />{auraFmt(u.aura_total_centi || 0)} Aura</span>
              {u.aura_today_centi > 0 && <span className="flex items-center gap-0.5 text-aura-mint"><TrendingUp className="h-3 w-3" />{auraFmt(u.aura_today_centi)}</span>}
            </div>
          )}
        </div>
      </button>
      {right}
      {showFollow && !u.is_self && (
        <FollowButton username={u.username} state={u.state || "follow"} followsMe={u.follows_me} />
      )}
    </div>
  );
}
